import { render, staticRenderFns } from "./cardTitle.vue?vue&type=template&id=45d0d5a7&scoped=true&"
import script from "./cardTitle.vue?vue&type=script&lang=js&"
export * from "./cardTitle.vue?vue&type=script&lang=js&"
import style0 from "./cardTitle.vue?vue&type=style&index=0&id=45d0d5a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d0d5a7",
  null
  
)

export default component.exports